import { useEffect, useState } from "react";

import proxy from "api/proxy";
import { fetchMelhous } from "./hotelDefaults";
import { ENGAGE_FIELDS, MELHOUS_MODEL } from "../constants";

function toForm(melhous) {
  return {
    link_melhous: melhous.link_melhous ?? "",
    require_table_qr: Boolean(melhous.require_table_qr),
  };
}

function getChanges(form, saved) {
  const changes = {};
  if (form.link_melhous !== saved.link_melhous) {
    changes.link_melhous = form.link_melhous.trim() || null;
  }
  if (form.require_table_qr !== saved.require_table_qr) {
    changes.require_table_qr = form.require_table_qr;
  }
  return changes;
}

function useEngageForm() {
  const [melhousId, setMelhousId] = useState(null);
  const [form, setForm] = useState(null);
  const [saved, setSaved] = useState(null);
  const [failed, setFailed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const melhous = await fetchMelhous(ENGAGE_FIELDS);
      if (cancelled) return;
      if (!melhous) {
        setFailed(true);
        return;
      }
      const initial = toForm(melhous);
      setMelhousId(melhous.id);
      setForm(initial);
      setSaved(initial);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  function handleChange(name, value) {
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSave() {
    setSaving(true);
    setSaveError(false);
    const { error } = await proxy.saveQuery({
      model: MELHOUS_MODEL,
      storeRec: { id: melhousId, ...getChanges(form, saved) },
      fieldsNames: ["id"],
    });
    setSaving(false);
    if (error) {
      setSaveError(true);
      return;
    }
    setSaved(form);
    setShowAlert(true);
  }

  const dirty =
    form && saved && Object.keys(getChanges(form, saved)).length > 0;

  return {
    melhousId,
    form,
    failed,
    saving,
    saveError,
    showAlert,
    dirty,
    handleChange,
    handleSave,
    closeAlert: () => setShowAlert(false),
  };
}

export default useEngageForm;
